export default __webpack_public_path__ + "static/4p_2_2-0e3ba9d993a352e34c2613d215c21d8a.jpg";